import React from "react"
import axios from 'axios'
import { MDCLinearProgress } from '@material/linear-progress';
import $ from "jquery";
import { MDCDataTable } from '@material/data-table';
import { MDCSnackbar } from '@material/snackbar';
import { MDCTabBar } from '@material/tab-bar';
import {MDCFormField} from '@material/form-field';
import {MDCCheckbox} from '@material/checkbox';
import { MDCTextField } from '@material/textfield';
import { MDCRipple } from '@material/ripple';

function roundPlus(number) { if (isNaN(number)) return false; var m = Math.pow(10, 2); return Math.round(number * m) / m; }

var snackbar 

class ChequeBox extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    new MDCTextField(document.querySelector('#chequeAmountField'));
    new MDCTextField(document.querySelector('#chequeTimesField'));
    new MDCTextField(document.querySelector('#chequeCodeField'));
    new MDCRipple(document.querySelector('#chequeCreateBtn'));
    snackbar = new MDCSnackbar(document.querySelector('#adminSnackbar'));
    snackbar.openText = function (text) {
      document.querySelector("#adminSnackbarText").innerHTML = text
      snackbar.open()
    }

    document.querySelector('#chequeCreateBtn').onclick = () => {
      axios.get(`https://nakrutkatop.com:443/api/admin/cheque?amount=${document.querySelector("#chequeAmountInput").value}&times=${document.querySelector("#chequeTimesInput").value}`, { withCredentials: true })
        .then(res => {
          if (!res.data.ok) return  snackbar.openText(res.data.descr)
            snackbar.openText(res.data.descr)
            document.querySelector("#chequeCodeInput").value = res.data.code
            document.querySelector('#chequeCodeField').classList.add("mdc-text-field--label-floating")
            document.querySelector('#chequeCodeLabel').classList.add("mdc-floating-label--float-above")
        })
    }
  }

  render(props) {
    return <div className="ibox" style={{ width: "333px", flex: "0 0 333px", maxWidth: "100%", marginTop: "8px" }}>
    <h3 className="ibox_title">Создание чека</h3>
    <div className="ibox_content" style={{ padding: "0 16px 16px 16px" }}>
    
      <div style={{display: "flex"}}>
      <label class="mdc-text-field mdc-text-field--outlined" id="chequeAmountField" style={{ width: "100%", display: "inline-flex",  marginRight: "8px" }}>
        <input type="number" class="mdc-text-field__input" aria-labelledby="modalLabelLink" id="chequeAmountInput" />
        <span class="mdc-notched-outline">
          <span class="mdc-notched-outline__leading"></span>
          <span class="mdc-notched-outline__notch" id="outline1">
            <span class="mdc-floating-label" id="chequeAmountLabel">Сумма</span>
          </span>
          <span class="mdc-notched-outline__trailing"></span>
        </span>
      </label>
    
      <label class="mdc-text-field mdc-text-field--outlined" id="chequeTimesField" style={{ width: "100%", display: "inline-flex" }}>
         <input type="number" class="mdc-text-field__input" aria-labelledby="modalLabelLink" id="chequeTimesInput" />
        <span class="mdc-notched-outline">
          <span class="mdc-notched-outline__leading"></span>
          <span class="mdc-notched-outline__notch" id="outline2">
            <span class="mdc-floating-label" id="chequeTimesLabel">Количество</span>
          </span>
          <span class="mdc-notched-outline__trailing"></span>
        </span>
      </label>
      </div>

      <div style={{display: "flex"}}>
   
      <button class="mdc-button mdc-button--raised mdc-ripple-upgraded" id="chequeCreateBtn" style={{ width: "100%", display: "inline-flex", height: "56px", borderRadius: "6px",  marginRight: "8px"  }}>
        <div class="mdc-button__ripple" style={{borderRadius: "6px"}}></div>
        <i className="fas fa-plus"></i>
        <span className="mdc-button__label">&nbsp;&nbsp;Создать</span>
      </button>

      <label class="mdc-text-field mdc-text-field--outlined" id="chequeCodeField" style={{ width: "100%", display: "inline-flex"  }}>
        <input type="text" class="mdc-text-field__input" aria-labelledby="modalLabelLink" id="chequeCodeInput" />
        <span class="mdc-notched-outline">
          <span class="mdc-notched-outline__leading"></span>
          <span class="mdc-notched-outline__notch" id="outline2">
            <span class="mdc-floating-label" id="chequeCodeLabel">Чек</span>
          </span>
          <span class="mdc-notched-outline__trailing"></span>
        </span>
      </label>

        </div>
    </div>
    </div>
  }
}

class DepositsListBox extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.loadServices(false)
    setTimeout(()=>{
        const checkbox = new MDCCheckbox(document.querySelector('.mdc-checkbox'));
        const formField = new MDCFormField(document.querySelector('.mdc-form-field'));
        formField.input = checkbox;
    }, 1500)

  }

  render(props) {

    const { error, isLoaded, items } = this.props.state;
    if (error) {
      return <div>Ошибка: {error.message}</div>;
    } else if (!isLoaded) {
      return <div>Загрузка...</div>;
    } else {
      return (
        <div className="ibox" style={{  flex: "0 0 1000px", minWidth: "100%", margin: "24px 24px 24px 0", overflowX: "auto" }}>
          <h3 className="ibox_title" style={{ paddingRight: "10px" }}>Пополнения
          
          <div>
          <div className="mdc-form-field">
  <div className="mdc-checkbox">
    <input type="checkbox" className="mdc-checkbox__native-control" id="checkbox-1" onClick={(cb)=> {
            this.props.loadServices(document.querySelector("#checkbox-1").checked)
        }}/>
    <div className="mdc-checkbox__background">
      <svg className="mdc-checkbox__checkmark"viewBox="0 0 24 24">
        <path className="mdc-checkbox__checkmark-path" fill="none" d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
      </svg>
      <div className="mdc-checkbox__mixedmark"></div>
    </div>
    <div className="mdc-checkbox__ripple"></div>
  </div>
  <label for="checkbox-1" style={{marginBottom: 0, paddingLeft: 0, color: "#fff", paddingRight: "16px"}}>Неоплаченные</label>
</div>
              </div>
          </h3>

          <div className="ibox_content" style={{ padding: "0" }}>
              <div className="mdc-data-table" style={{ width: "100%" }}>
                <table className="mdc-data-table__table" aria-label="Dessert calories">
                  <thead>
                    <tr className="mdc-data-table__header-row">
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">#</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">ID пользователя</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Сумма</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Промокод</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Сервис</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Способ</th>
                      <th className="mdc-data-table__header-cell" role="columnheader" scope="col" data-column-id="comments">Статус</th>
                    </tr>
                  </thead>
                  <tbody className="mdc-data-table__content" id="historyTable">
                    {items.map(item => (<tr className="mdc-data-table__row">
                      <td className="mdc-data-table__cell"> {item.n}</td>
                      <td className="mdc-data-table__cell"> {item.uid}</td>
                      <td className="mdc-data-table__cell"> {roundPlus(item.amount)}$</td>
                      <td className="mdc-data-table__cell"> {item.promocode}</td>
                      <td className="mdc-data-table__cell"> {item.product}</td>
                      <td className="mdc-data-table__cell"> {item.way}</td>
                      <td className="mdc-data-table__cell"> {item.status ? "оплачен": "неоплачен"}</td>
                    </tr>
                    ))}
                  </tbody>
                </table>
            </div>
          </div>
        </div>
      );
    }


  }
}

class DepositsTab extends React.Component {
  constructor(props) {
    super(props);
    this.loadServices = this.loadServices.bind(this)

    this.state = {
      error: null,
      isLoaded: false,
      items: []
    }

  }

  componentDidMount() {

  }

  loadServices(loadUnpaid) {
    axios.get(`https://nakrutkatop.com:443/api/admin/deposits${loadUnpaid ? "/unpaid": ""}`, { withCredentials: true })
      .then(res => {
        document.getElementById("mainContent").style.opacity = 1
        this.setState({
          isLoaded: true,
          items: res.data.deposits
        }, () => { new MDCDataTable(document.querySelector('.mdc-data-table')); })
      })
  }

  render(props) {
    return <div id="mainContent" style={{ opacity: "0", transition: "1.5s opacity" }}>
      <div className="irow" style={{ display: "flex", flexWrap: "wrap", paddingTop: "8px" }}>
        <ChequeBox/>
      </div>
      <div className="irow" style={{ display: "flex", flexWrap: "wrap" }}>
        <DepositsListBox loadServices={this.loadServices} state={this.state} />
      </div>
    </div>
  }
}

export default DepositsTab

